export const video = () => {
  const videoEls = document.querySelectorAll('.common__video');

  if (typeof videojs === 'undefined') return;

  // ── Play/Pause observer ──────────────────────────────────────
  // Only play when 50% visible; pause otherwise.
  const playObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const player = entry.target.vjsPlayer;
      if (!player) return;

      if (entry.isIntersecting) {
        player.play().catch(() => {});
      } else {
        player.pause();
      }
    });
  }, { root: null, rootMargin: '0px', threshold: 0.5 });

  // ── Mute button (mobile only) ───────────────────────────────
  const createMuteBtn = (player) => {
    const wrapper = player.el();
    const btn = document.createElement('button');
    btn.className = 'common__muteBtn';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Toggle mute');

    // Use inline‐style SVGs with explicit width/height for Safari/iOS
    const mutedIcon = `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>`;
    const unmutedIcon = `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>`;

    const updateIcon = () => {
      btn.innerHTML = player.muted() ? mutedIcon : unmutedIcon;
    };
    updateIcon();

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      player.muted(!player.muted());
    });
    player.on('volumechange', updateIcon);

    // Place inside the Video.js wrapper so it sits above the player chrome
    wrapper.appendChild(btn);
  };

  // ── Init a single video ──────────────────────────────────────
  const initVideo = (el) => {
    const isMobile = window.innerWidth <= 768;
    const sources = Array.from(el.querySelectorAll('source'));
    let correctSrc = '';

    const posterPC = el.getAttribute('data-poster-pc') || '';
    const posterSP = el.getAttribute('data-poster-sp') || '';
    const correctPoster = isMobile ? posterSP : posterPC;

    sources.forEach((source) => {
      const mediaAttr = source.getAttribute('media');
      if (isMobile && mediaAttr === '(max-width: 768px)') {
        correctSrc = source.getAttribute('src') || source.getAttribute('data-src');
      } else if (!isMobile && !mediaAttr) {
        correctSrc = source.getAttribute('src') || source.getAttribute('data-src');
      }
    });

    el.innerHTML = '';

    const player = videojs(el, {
      controls: false,
      muted: true,
      autoplay: false,
      playsinline: true,
      loop: true,
      fluid: true,
      aspectRatio: isMobile ? '9:16' : '16:9',
      preload: 'metadata', // Only grab metadata+poster frame, not the full file
      poster: correctPoster,
      sources: [{ src: correctSrc, type: 'video/mp4' }],
    });

    player.ready(() => {
      createMuteBtn(player);

      player.el().vjsPlayer = player;
      playObserver.observe(player.el());
    });
  };

  // ── Lazy‐init observer ──────────────────────────────────────
  // Only initialize Video.js when the element is 200px from viewport.
  // Smaller margin = fewer simultaneous downloads.
  const lazyObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          initVideo(entry.target);
        }
      });
    },
    { root: null, rootMargin: '200px 0px', threshold: 0 }
  );

  // ── Bootstrap ────────────────────────────────────────────────
  videoEls.forEach((el) => {
    const isMobile = window.innerWidth <= 768;
    const poster = isMobile
      ? el.getAttribute('data-poster-sp')
      : el.getAttribute('data-poster-pc');

    // Show poster as native poster AND as CSS background so the user
    // always sees a thumbnail even before Video.js takes over.
    if (poster) {
      el.setAttribute('poster', poster);
      el.style.backgroundImage = `url(${poster})`;
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center';
    }
    el.setAttribute('preload', 'none');
    el.removeAttribute('autoplay');

    lazyObserver.observe(el);
  });
};
